// URL constants
export const API_ENDPOINTS = {
    BASE_URL: "https://techsolutionsservice.ustdev.com/",
    GOAL_CONFIG_URL: "https://techsolutionsservice.ustdev.com/goals/config",
    SUPPLIER_URL: "https://techsolutionsservice.ustdev.com/supplier/",
    MAPPED_SUPPLIER_GOALS_URL: "https://techsolutionsservice.ustdev.com/goals/mapped-supplier-goals/",
};

// Constants for HTTP methods
export const API_METHOD_GET = "GET";
export const API_METHOD_POST = "POST";
export const API_METHOD_PUT = "PUT";
export const API_METHOD_DELETE = "DELETE";

// API Endpoints
export const API_ENDPOINT_GOALSDATA = "/goals/config";
export const API_ENDPOINT_PILLARDATA = "/goals/supplier/";
export const API_ENDPOINT_ADDORUPDATE = "/goals/addOrUpdateGoalData";

// API Header
export const API_HEADER_AUTH = () => ({
    headers:{
        Authorization:`Bearer ${sessionStorage.getItem("authToken")}`,
    }           
})